// This method must match the logic in address.rb#get_formatted_street
export function getFormattedStreet(city, street, registrationNumber, buildingNumber) {
  registrationNumber = registrationNumber === 0 ? null : registrationNumber
  buildingNumber = buildingNumber === 0 ? null : buildingNumber
  street = street || city

  if (registrationNumber && buildingNumber) {
    return `${street}${(street ? " " : "") + registrationNumber}/${buildingNumber}`
  } else if (buildingNumber || registrationNumber) {
    return `${street}${(street ? " " : "") + (buildingNumber || registrationNumber)}`
  } else {
    return street
  }
}
